import { render, staticRenderFns } from "./CourseModality.vue?vue&type=template&id=d6799ce6"
import script from "./CourseModality.vue?vue&type=script&lang=js"
export * from "./CourseModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6799ce6')) {
      api.createRecord('d6799ce6', component.options)
    } else {
      api.reload('d6799ce6', component.options)
    }
    module.hot.accept("./CourseModality.vue?vue&type=template&id=d6799ce6", function () {
      api.rerender('d6799ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/CourseModality.vue"
export default component.exports